import { render } from "./authentication.vue?vue&type=template&id=56118cb5&scoped=true"
import script from "./authentication.vue?vue&type=script&lang=js"
export * from "./authentication.vue?vue&type=script&lang=js"

import "./authentication.vue?vue&type=style&index=0&id=56118cb5&lang=scss&scoped=true"
import "./authentication.vue?vue&type=style&index=1&id=56118cb5&lang=scss"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56118cb5"]])

export default __exports__